export const SKYBOX_PRESETS = [
  { id: "clear-sky", label: "Clear sky", file: "skyboxes/clear-sky.jpg" },
  { id: "overcast-sky", label: "Overcast sky", file: "skyboxes/overcast-sky.jpg" },
  { id: "sunset-sky", label: "Sunset sky", file: "skyboxes/sunset-sky.jpg" },
  { id: "pure-sky", label: "Pure sky", file: "skyboxes/pure-sky.jpg" },
  { id: "qwantani-noon", label: "Qwantani noon", file: "skyboxes/qwantani-noon.jpg" },
  { id: "kloppenheim-06", label: "Kloppenheim 06", file: "skyboxes/kloppenheim-06.jpg" },
  { id: "qwantani-dusk", label: "Qwantani dusk", file: "skyboxes/qwantani-dusk.jpg" },
  { id: "evening-road", label: "Evening road", file: "skyboxes/evening-road.jpg" },
] as const

export type SkyboxId = typeof SKYBOX_PRESETS[number]["id"]
